module.exports = __webpack_public_path__ + "static/personal_data_processing_policy-459bdd242d003411e6ecd04c6706ba92.pdf";